<div class="sub-responsibles-registry-container">
  <!-- Breadcrumb -->
  <div class="mb-4">
    <p-breadcrumb 
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()" 
      [home]="{icon: 'pi pi-home', routerLink: '/axa/suppliers-dashboard', ariaLabel: 'Home'}">
    </p-breadcrumb>
  </div>

  <!-- Page Header -->
  <section class="page-header">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-users header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1>Registro Sub-Responsabili</h1>
          <p class="subtitle">Gestione e monitoraggio dei sub-responsabili</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Reusable Table Component -->
  <app-registry-table
    [title]="tableTitle"
    [icon]="tableIcon"
    [columns]="columns"
    [data]="data()"
    [loading]="loading()"
    [showClearFiltersButton]="true"
    [showExportButton]="true"
    (onDetailClick)="onDetailClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onClearFilters)="onClearFilters()"
    (onExport)="onExport()"
  />

  <!-- Toast for notifications -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true" />
</div>
